import clsx from 'clsx'
import { MenuItem } from '@mui/material'
import { Link } from 'react-router-dom'
import { UserMenuItemLinkProps } from './_props'
import useStyles from './styles/UserMenuItemStyles'
import UserMenuItemLabel from './UserMenuItemLabel'
import { useUserMenuContext } from './UserMenuContext'

const UserMenuItem = ({
    isExternal,
    action,
    label,
    icon,
    enabled,
    onMouseOver,
    hasSubItem,
    separator,
    displayBadge,
}: UserMenuItemLinkProps) => {
    const classes = useStyles()

    const { update, state } = useUserMenuContext()

    const changeMenuOpenState = () => {
        update({ isOpen: !state.isOpen })
    }

    return (
        <div>
            {enabled !== false && (
                <div key={`user-menu-item-${label}`}>
                    {separator !== false && <div className={classes.UserMenuItemSeparator} />}
                    <MenuItem
                        className={classes.UserMenuMenuItem}
                        onClick={() => {
                            if (typeof action === 'function') {
                                action()
                            }
                            if (!hasSubItem) changeMenuOpenState()
                        }}
                    >
                        {typeof action === 'string' && (
                            <Link
                                className={clsx(
                                    classes.UserMenuLink,
                                    classes.UserMenuMenuItemLabel,
                                    classes.UserMenuMenuItemLinkLabel,
                                )}
                                onMouseOver={onMouseOver}
                                to={action}
                                target={isExternal ? '_blank' : ''}
                            >
                                <UserMenuItemLabel label={label} icon={icon} displayBadge={displayBadge} />
                            </Link>
                        )}
                        {typeof action === 'function' && (
                            <div
                                className={clsx(
                                    classes.UserMenuMenuItemLabel,
                                    !hasSubItem && classes.UserMenuMenuItemLinkLabel,
                                )}
                            >
                                <UserMenuItemLabel label={label} icon={icon} displayBadge={displayBadge} />
                            </div>
                        )}
                    </MenuItem>
                </div>
            )}
        </div>
    )
}

export default UserMenuItem
